import React from "react";
import "../../../styles/pages-styles/main-dashboard-pages-styles/user-sidebar-pages/Subscribe.css";
import { handlePayment } from "../../../services/paymentService";

const Subscribe = () => {
  
  const accessToken = sessionStorage.getItem("token");
  const userEmail = sessionStorage.getItem("userEmail");
  const amount = 10000;

  return (
    <div className="subscribe-container">
      <div className="subscribe-header">
        <h1 className="subscribe-title">Choose Your Plan</h1>
        <p className="subscribe-subtitle">
          Select the subscription that fits your learning needs
        </p>
      </div>

      <div className="subscribe-card">
        <div className="subscribe-grid">
          {/* Empty top-left cell */}
          <div className="subscribe-cell subscribe-empty-header"></div>

          {/* Free column header */}
          <div className="subscribe-cell subscribe-free-header">
            <h2 className="subscribe-plan-title">Free</h2>
            <p className="subscribe-plan-subtitle">Get started</p>
            <div className="subscribe-price">
              <span className="subscribe-price-amount">₦0</span>
              <span className="subscribe-price-period">/month</span>
            </div>
          </div>

          {/* Premium column header */}
          <div className="subscribe-cell subscribe-premium-header">
            <h2 className="subscribe-plan-title">Premium</h2>
            <p className="subscribe-plan-subtitle">Full access</p>
            <div className="subscribe-price">
              <span className="subscribe-price-amount">₦10,000</span>
              <span className="subscribe-price-period">/month</span>
            </div>
          </div>

          {/* Feature rows */}
          {/* Questions row */}
          <div className="subscribe-cell subscribe-feature">
            Practice Questions
          </div>
          <div className="subscribe-cell subscribe-free-feature">
            Limited (50/month)
          </div>
          <div className="subscribe-cell subscribe-premium-feature">
            Unlimited
          </div>

          {/* Mock exams row */}
          <div className="subscribe-cell subscribe-feature">Mock Exams</div>
          <div className="subscribe-cell subscribe-free-feature">No access</div>
          <div className="subscribe-cell subscribe-premium-feature">
            Unlimited exams
          </div>

          {/* Knowledge Tutor row */}
          <div className="subscribe-cell subscribe-feature">
            Knowledge Tutor
          </div>
          <div className="subscribe-cell subscribe-free-feature">
            <span className="subscribe-not-included">✗</span>
          </div>
          <div className="subscribe-cell subscribe-premium-feature">
            <span className="subscribe-included">✓</span>
          </div>

          {/* Textbooks row */}
          <div className="subscribe-cell subscribe-feature">Textbooks</div>
          <div className="subscribe-cell subscribe-free-feature">
            No access
          </div>
          <div className="subscribe-cell subscribe-premium-feature">
            Full access
          </div>

          {/* CTA section */}
          <div className="subscribe-cell"></div>
          <div className="subscribe-cell subscribe-free-cta">
            {/* Free button removed as requested */}
          </div>
          <div className="subscribe-cell subscribe-premium-cta">
            <button 
                className="subscribe-premium-button"
                onClick={() => {
                  handlePayment(userEmail, amount, accessToken)
                }}>Go Premium</button>
          </div>
        </div>
      </div>

      <div className="subscribe-footer">
        Questions? Contact our support team at support@example.com
      </div>
    </div>
  );
};

export default Subscribe;
